<!-- sidebar -->
<mat-sidenav-container>
    <mat-sidenav #sidenav mode="side">
        <div class="left-sidebar left-sidebar-1" id="navbar-side">
            <div class="sidebar-content-wrapper">
            <div class="content-minus-footer">
                <div class="menu-title-wrap">
                    <button class="btn-collapse bg-transparent border-0"
                            (click)="sidebarToggle()">
                        <i class="sli-close close-icon"></i>
                    </button>
                    <span translate>Menu</span>
                </div>
                    <div class="list-unstyled">
                        <div *ngFor="let item of data"
                             class="list-item"
                             [ngSwitch]="item.type">
                            <div *ngIf="item.is_active">
                                <!-- components -->
                                <div *ngSwitchCase="'ngx-component'">
                                    <div [innerHTML]="item.link | safe: 'html'" ></div>
                                </div>
                                <div *ngSwitchCase="'component'">
                                    <div *ngIf="item.link === 'user-login'"
                                         class="btn-light btn-sidebar btn-sidebar-1 p-0">
                                        <user-login></user-login>
                                    </div>
                                    <div *ngIf="item.link === 'langs-sidebar' && showLangs">
                                        <div class="btn-light btn-flat btn-sidebar btn-sidebar-1 has-children lang-wrap"
                                             data-target="#langs-sidebar"
                                             data-toggle="collapse">
                                            <i [ngClass]="item.icon"></i>
                                            <span class="title">{{item.title}}</span>
                                        </div>
                                        <div class="list-unstyled collapse" id="langs-sidebar">
                                            <langs-sidebar></langs-sidebar>
                                        </div>
                                    </div>
                                    <div *ngIf="item.link === 'main-header-search-form'">
                                        <div class="btn-default btn-flat btn-sidebar btn-sidebar-1"
                                             (click)="showSearchArea()">
                                            <i [ngClass]="item.icon"></i>
                                            <span class="title">{{item.title}}</span>
                                        </div>
                                    </div>
                                    <div  *ngIf="item.link === 'variety-sidebar'">
                                        <div class="btn-default btn-flat btn-sidebar btn-sidebar-1 has-children lang-wrap"
                                             data-target="#variety-sidebar"
                                             data-toggle="collapse">
                                            <i [ngClass]="item.icon"></i>
                                            <span class="title" translate>{{item.title}}</span>
                                        </div>
                                        <div class="list-unstyled collapse" id="variety-sidebar">
                                            <variety-options [sidebar]= true></variety-options>
                                        </div>
                                    </div>
                                    <div *ngIf="item.link === 'catalogue-sidebar'">
                                        <!--<tree-view [standAlone]="true" (loadGroup)="sidebarToggle()">-->
                                        <!--</tree-view>-->
                                    </div>
                                </div>
                                <!-- /components -->
                                <!-- links -->
                                <div *ngSwitchCase="'link'">
                                    <a class="btn-light btn-sidebar btn-sidebar-1"
                                       [ngClass]="item.class"
                                       routerLink="{{item.base_link | translate}}"
                                       [queryParams]="item.query_params">
                                        <i [ngClass]="item.icon"></i>
                                        <span class="title">{{item.title}}</span>
                                    </a>
                                </div>
                                <!-- /links -->
                            </div>
                            <div *ngIf="!item.is_active && item.link === 'langs-sidebar'">
                                <section [hidden]="true">
                                    <langs-sidebar></langs-sidebar>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-sidenav>
</mat-sidenav-container>
<!-- /sidebar -->

<div *ngIf="showSearch">
    <search-sidebar (hideSearchEvent)="hideSearch()"></search-sidebar>
</div>
